
                import Handlebars from 'handlebars/dist/handlebars.runtime';
                const templateFunction = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class='gallery__null-item'>\n  <div class='null-item__thumb'><img src='"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"imgEmpty") || (depth0 != null ? lookupProperty(depth0,"imgEmpty") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"imgEmpty","hash":{},"data":data,"loc":{"start":{"line":2,"column":42},"end":{"line":2,"column":56}}}) : helper))) != null ? stack1 : "")
    + "' alt='Null in box' min-width='320' min-height='320'\n      loading=\"lazy\" /></div>\n</div>";
},"useData":true});
                export default templateFunction;
                